document.addEventListener('DOMContentLoaded', function () {
  const DESKTOP_BREAKPOINT = 1024;
  const AUTOPLAY_DELAY = 5000;
  let isSwiperInView = false;

  const mainImage = document.querySelector('.main-image');
  const additionalImages = document.querySelectorAll('.additional-image');

  const thumbsWrap = document.querySelector('.media__thumbnail-list');
  const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
  const thumbImages = document.querySelectorAll('.media__thumb img');

  let prevValue = document.querySelector('.size_slider input:checked')?.value;

  document.querySelectorAll('.size_slider input').forEach(function (input) {
    input.addEventListener('change', function () {
      const mainMedia = input.dataset.mainMedia;
      const additionalMedia = input.dataset.additionalMedia?.split(',') || [];

      mainImage.src = mainMedia;

      additionalImages.forEach(function (img, index) {
        if (additionalMedia[index]) {
          img.src = additionalMedia[index].trim();
        }
      });

      thumbImages.forEach(function (img, index) {
        if (index === 0) {
          img.src = mainMedia;
        } else if (additionalMedia[index - 1]) {
          img.src = additionalMedia[index - 1].trim();
        }
      });

      swiper.slideToLoop?.(0, 0) ?? swiper.slideTo(0, 0);

      requestAnimationFrame(() => {
        swiper.autoplay?.stop();
        swiper.autoplay?.start();
      });

      const _lpExtras = readPdpEventExtras();
      dataLayer.push({
        event: 'custom_event',
        event_name: 'product_color_change',
        parameter: JSON.stringify({
          from: prevValue,
          value: input.value,
          content_url: input.dataset.productUrl,
          type: 'product',
          item_id: _lpExtras.item_id,
          product_collection: _lpExtras.product_collection
        })
      });
    });
  });

  let swiper = new Swiper('.pil-es-kit-lp .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    autoplay: { delay: AUTOPLAY_DELAY, disableOnInteraction: false },
    pagination: {
      el: '.pil-es-kit-lp .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      1024: {
        autoplay: { delay: AUTOPLAY_DELAY, disableOnInteraction: false },
        centeredSlides: false,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-navigation .swiper-button-next',
          prevEl: '.swiper-navigation .swiper-button-prev'
        },
        allowTouchMove: false,
        speed: 1,
        pagination: false
      }
    },
    on: {
      slideChange(swiper) {
        if (window.innerWidth < DESKTOP_BREAKPOINT) return;
        if (!isSwiperInView) return;

        setActiveThumb(swiper.realIndex);

        requestAnimationFrame(() => {
          scrollActiveThumbIntoView(swiper.realIndex);
        });
      }
    }
  });

  const swiperEl = document.querySelector('.pil-es-kit-lp .swiper');

  const observer = new IntersectionObserver(
    ([entry]) => {
      isSwiperInView = entry.isIntersecting;
    },
    {
      root: null,
      threshold: 0.7
    }
  );

  if (swiperEl) {
    observer.observe(swiperEl);
  }

  function setActiveThumb(index) {
    if (!thumbs.length) return;

    thumbsWrap
      .querySelector('.is-active-thumb')
      ?.classList.remove('is-active-thumb');
    thumbs[index]?.classList.add('is-active-thumb');
  }

  document.addEventListener('click', e => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb || !thumbsWrap) return;

    const index = Number(thumb.dataset.index);

    thumbs.forEach(el => el.classList.remove('is-active-thumb'));
    thumbs[index]?.classList.add('is-active-thumb');

    swiper.slideToLoop(index);

    dataLayer.push({
      event: 'custom_event',
      event_name: 'thumbnail_media_click',
      parameter: JSON.stringify({
        content_number: `${index + 1}`,
        type: `image`
      })
    });

    if (swiper.autoplay) {
      swiper.autoplay.stop();
      swiper.autoplay.start();
    }
  });

  document.addEventListener('click', e => {
    const navBtn = e.target.closest('.swiper-navigation button');
    if (!navBtn) return;

    dataLayer.push({
      event: 'custom_event',
      event_name: 'gallery_navigate',
      parameter: ''
    });
  });

  const scrollActiveThumbIntoView = index => {
    const activeThumb = document.querySelector(
      `[data-thumb][data-index="${CSS.escape(String(index))}"]`
    );
    if (!activeThumb) return;

    activeThumb.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  };

  document.addEventListener('click', e => {
    const input = e.target.closest('.item input');
    if (!input || !input.closest('.pil-es-kit-lp')) return;

    const method =
      typeof swiper.slideToLoop === 'function' ? 'slideToLoop' : 'slideTo';

    swiper[method](0, 0);
  });

  additionalImages.forEach(function (img) {
    img.classList.remove('tw-opacity-0');
  });
  if (window.initStampedReviews) {
    window.initStampedReviews({ scopeSelector: '.pil-es-kit-lp' });
  }
});
